module.exports = __webpack_public_path__ + "img/gallery1xxxhdpi.7a0e8da1.png";